import { HttpRequest } from "../../services/httpRequest";


export const loadInfoUser = async (documento) => {
    try {
        const data = await HttpRequest.getInfoUser(documento);
        return data.message.info;
    } catch (error) {
        console.log(error);
    }
}


export const loadInfoUserAuth = async (documento) => {
    try {
        const data = await HttpRequest.getUserAuth(documento);
        return data.message.user;
    } catch (error) {
        console.log(error);
    }
}

export const firmaElectronica = 145000;